<template>

	<div class="tgju-widget-content full-padding">
		
			<div class="list-widget list-dash-items list-widget-structure" >
				<div class="tgju-widget light min-h-unset">
					<div class="list-widget  list-row bold list-row-title">
						<div class="list-col l-title dot head-color no-border">
							<span>سوابق خرید</span>
						</div>
						<div class="list-col l-item head-color" v-tooltip="'بروزرسانی'">
							<i class="uil uil-sync pointer" @click="getHistory()"></i>
						</div>
						<div class="list-col l-item head-color">
							<i class="uil uil-shopping-cart-alt"></i>
						</div>
					</div>
					<div class="tgju-widget-content full-padding">
						<slot v-if="widgetLoad">
							<div class="text-center p-2">
								<div class="widget-loading"></div>
							</div>
						</slot>
						<slot v-else>
							<table v-if="histories.data.length" class="widget-table widget-table-lg">
								<thead>
									<tr>
										<th class="text-center">عنوان شاخص</th>
										<th class="text-center hide-640">تعداد</th>
										<th class="text-center">ارزش واحد</th>
										<th class="text-center hide-table-r hide-640">ارزش کل</th>
										<th class="text-center">زمان خرید</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="history in histories.data" :key="history.id">
										<td class="border-l text-center">
											{{ history.label }}
										</td>
										<td class="border-l text-center hide-640">
											{{ formatPrice(history.total) }}
											</td>
										<td class="border-l text-center">
											{{ formatPrice(history.amount) }}
										</td>
										<td class="border-l text-center hide-table-r hide-640">
											{{ formatPrice(history.price) }}
										</td>
										<td class="border-l text-center">
											{{ toRelative(history.created_at) }}
										</td>
									</tr>
								</tbody>
							</table> 

							<slot v-else>
								<div class="popup-dash-empty">
									<i class="uil uil-shopping-cart-alt" aria-hidden="true"></i>
									<span>مقداری برای نمایش وجود ندارد</span>
								</div>
							</slot>
						</slot>
					</div>
				</div>
			</div>

			<div v-if="histories.last_page > 1" class="p-5 d-flex justify-content-center">
				<Paginate :page-count="histories.last_page" :click-handler="getHistory" :prev-text="'قبل'" :next-text="'بعد'" :container-class="'pagination'" ></Paginate>
			</div>

		
	</div>

</template> 


<style lang="scss" scoped>
	thead {
		display: table-header-group;
		vertical-align: middle;
		border-color: inherit;
	}
</style>

<script>
	// این کامپوننت اجزاری سابقه خرید را در ماژول سرمایه گذاری دارا می باشد
	import moment from "moment-jalaali";
	import Paginate from "vuejs-paginate";


	export default {
		name: 'BuyHistoryComponent',
		components: {
			Paginate
		},
		data: function () {
			return {
				histories: [],
				widgetLoad: true,
			}
		},
		mounted() {
			// این متد در زمان ایجاد کامپووننت فرا خوانده میشود
			this.getHistory();
		},
		methods: {
			// این متد جهت نمایش مناسب زمان مورد استفاده قرار میگیرد
			toRelative(date) {
				if (moment().diff(moment(date), 'days') < 30)
					return moment(date).fromNow();
				else
					return moment(date).format("dddd jD jMMMM jYYYY / HH:mm");
			},
			// این متد جهت نمایش بهتر نرخ ها و قیمت ها می باشد // جدا کننده قیمت با کاما
			formatPrice(value) {
				return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			},
			// این متد وظیفه ی ارسال درخواست به سرور جهت نمایش تاریخچه ی خرید کاربر
			getHistory(page) {
				this.widgetLoad = true;
				let api_data = {
					page : page ? page : 1,
				};

				// ارسال درخواست ای پی آی
				this.$helpers.makeRequest('POST', '/investment/history/buy' , api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					this.histories = api_response.data.response.history;
					this.widgetLoad = false;

				});
			},
		},
	}
</script>